export const sdeTemplate = 'RUTemplate.csv';
export const rduTemplate = 'RDUTemplate.csv';
export const invoicePatternsDefaultFileName = 'InvoiceIdentificationPatterns.csv';
export const transactionHistoryData = 'Transactions.csv';
export const originalAdviceDefaultFileName = 'OriginalAdvice_EmailAttachments.zip';
